<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import FormDependenciesList from '@Alternatives/Forms/Components/FormDependenciesList.vue'

    import type { FormDefDependenciesReadModel } from '@Alternatives/Forms/Domain/readmodels'
    import type { FormDependenciesDialogViewModel } from '@Alternatives/Forms/Components/FormDependenciesDialog'

    // ---------------- props ----------------

    const props = defineProps<{
        viewModel: FormDependenciesDialogViewModel
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)
    const name = computed(() => vm.value.name)

    const deps = computed<FormDefDependenciesReadModel | null>(() => vm.value.deps)
    const dependantsCount = computed<number | null>(() => deps.value?.Count ?? null)

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Form dependencies</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4 v-if="!initialized">
                            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
                        </h4>
                        <div v-if="initialized">
                            <div class="alert alert-warning text-dark" role="alert">
                                <p>
                                    The form '<strong>{{name}}</strong>' is used in
                                    <strong>{{dependantsCount}}</strong> places.
                                </p>
                            </div>
                            <FormDependenciesList :readModel="deps" />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>